import { AD_CREATION_METHOD } from '@/consts.js';
import BaseEntity from '@/entities/BaseEntity';
import { parseNumber } from '@/utils/number.js';

export default class ScalingUpRuleSettings extends BaseEntity {
  name_prefix = '[Infinite.ad]';
  campaign_name_prefix = '[Infinite.ad]';
  adset_name = '{{month}}.{{date}}. {{time}} - {{post.message}}';
  stop_original = false;
  custom_cta_settings = false;
  cta_button = null;
  cta_url = null;
  smart_url = true;
  url_params = 'utm_source=facebook&utm_medium=cpc&utm_campaign={{campaign.name}}';
  dont_scale_expired_ads = true;
  _adset_budget = null;
  adset_budget_period = null;
  max_active_ads = null;
  adset_start_time = null;
  adset_end_time = null;
  adset_lifespan_max_days = null;

  ad_creation_method = AD_CREATION_METHOD.CREATIVE;
  ai_cta_content = false;
  ai_cta_button = false;
  ai_primary_text = false;
  ad_variants = 1;
  ai_ad_with_original_content = true;
  ap_creative_features = {};
  language = null;

  constructor(rawData) {
    super();
    this.updateWith(rawData);

    if (Array.isArray(this.ap_creative_features) && this.ap_creative_features.length === 0) {
      this.ap_creative_features = {};
    }
  }

  get adset_budget() {
    return this._adset_budget;
  }

  set adset_budget(value) {
    this._adset_budget = parseNumber(value);
  }

  updateWith(newValues) {
    if (!super.updateWith(newValues)) {
      return;
    }

    for (const [ key, value ] of Object.entries(newValues)) {
      if (
        (key === 'adset_start_time' || key === 'adset_end_time')
        && !!value
      ) {
        this[key] = new Date(value);
      }
    }
  }

  toObject() {
    const output = super.toObject();

    if ('campaign' in output) {
      output.campaign_id = output.campaign.id;
      delete output.campaign;
    }

    output.adset_budget = this.adset_budget;

    if (this.adset_start_time) {
      const startDate = new Date(this.adset_start_time);
      output.adset_start_time = startDate.toISOString();
    }

    if (this.adset_end_time) {
      const endDate = new Date(this.adset_end_time);
      output.adset_end_time = endDate.toISOString();
    }

    return output;
  }
}
